"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var headroom_js_1 = __importDefault(require("headroom.js"));
exports.default = (function (header) {
    var headroom = new headroom_js_1.default(header, {
        // vertical offset in px before element is first unpinned
        offset: 112,
        tolerance: {
            up: 5,
            down: 0
        },
        classes: {
            // when element is initialised
            initial: "is-sticky",
            // when scrolling up
            pinned: "is-pinned",
            // when scrolling down
            unpinned: "is-unpinned",
            // when above offset
            top: "is-top",
            // when below offset
            notTop: "is-notTop",
            // when at bottom of scroll area
            bottom: "is-bottom",
            // when not at bottom of scroll area
            notBottom: "is-notBottom",
            // when frozen method has been called
            frozen: "is-frozen"
        }
    });
    headroom.init();
    return headroom;
});
